
import { reactive, ref, watch, defineComponent } from 'vue'
import { useRoute } from 'vue-router'

import HeadingLv1 from '@/components/elements/HeadingLv1.vue'
import HeadingLv2 from '@/components/elements/HeadingLv2.vue'
import FaqLists from '@/components/block/FaqLists.vue'
import Alert from '@/components/elements/Alert.vue'
import FaqCategories from '@/components/block/FaqCategories.vue'
import FaqContact from '@/components/block/FaqContact.vue'

import { axiosSetting } from '@/utils/axiosSetting'

export default defineComponent({
  name: 'FaqList',
  components: {
    HeadingLv1,
    HeadingLv2,
    FaqLists,
    Alert,
    FaqCategories,
    FaqContact
  },
  beforeRouteEnter: async (to: any) => {
    const ajax = axiosSetting('cms', 'block')

    const data = await ajax
      .get(
        `${process.env.VUE_APP_WPAPI_URL}wp-json/wp/v2/faq_category?slug=${to.params.category}`
      )
      .then((res) => {
        // return res.data
        return res.data[0]
      })

    to.meta.breadCrumb.splice(1)

    to.meta.breadCrumb.push({ label: data.name })
    document.title = `${data.name} | ${document.title}`
  },
  beforeRouteUpdate: async (to: any) => {
    const ajax = axiosSetting('cms', 'block')

    const data = await ajax
      .get(
        `${process.env.VUE_APP_WPAPI_URL}wp-json/wp/v2/faq_category?slug=${to.params.category}`
      )
      .then((res) => {
        return res.data[0]
      })

    to.meta.breadCrumb[1].label = data.name
    document.title = `${data.name} | ${document.title}`
  },
  setup() {
    const state = reactive({
      loading: true
    })
    const category = ref([])
    const lists = ref([])
    const route = useRoute()
    const ajax = axiosSetting('cms', 'block')

    const getCategory = () => {
      ajax
        .get(
          `${process.env.VUE_APP_WPAPI_URL}wp-json/wp/v2/faq_category?slug=${route.params.category}`
        )
        .then((res) => {
          // category.value = res.data
          category.value = res.data[0]
        })
    }

    const getLists = () => {
      ajax
        .get(
          `${process.env.VUE_APP_WPAPI_URL}wp-json/wp/v2/faq?category=${route.params.category}&per_page=100`
        )
        .then((res) => {
          lists.value = res.data
          // console.log(route.params.category)
        })
        .finally(() => {
          state.loading = false
        })
    }

    getCategory()
    getLists()

    watch(
      () => route.params.category,
      () => {
        getCategory()
        getLists()
      }
    )

    return {
      state,
      category,
      lists
    }
  }
})
